<template>
  <PageLayout>
    <AboutSection />
    <SkillsSection />
    <PortfolioSection />
  </PageLayout>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import PageLayout from '@/layouts/PageLayout.vue';
import AboutSection from '@/components/sections/AboutSection.vue';
import SkillsSection from '@/components/sections/SkillsSection.vue';
import PortfolioSection from '@/components/sections/PortfolioSection.vue';

const LEGACY_HASHES: Record<string, string> = {
  '#uses': '#conhecimentos',
};

onMounted(() => {
  let { hash } = globalThis.location;
  if (!hash) return;

  hash = LEGACY_HASHES[hash] ?? hash;

  requestAnimationFrame(() => {
    const el = document.querySelector(hash);
    if (!el) return;
    const prefersReduced = globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({
      behavior: prefersReduced ? 'auto' : 'smooth',
      block: 'start',
    });
    if (hash !== globalThis.location.hash) {
      globalThis.history.replaceState(null, '', hash);
    }
  });
});
</script>
